export enum CustomerTypes {
  MANUAL = 'MANUAL',
}
